export default __webpack_public_path__ + "986bab62d4c333745089b8ac65566477.png";